<template>
  <div class="icon-text">
    <i :class="'icon icon-' + icon" />
    <div class="text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "IconText",
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-text {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid #d4d4d4;
}

.icon {
  font-size: 40px;
}

.text {
  @include t__utility-label-30;
}
</style>
